//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ValidationProvider } from 'vee-validate'
import FormLabelPassword from '~/components/Form/FormLabelPassword'

export default {
  name: 'FormInputPassword',
  components: {
    FormLabelPassword,
    ValidationProvider,
  },
  props: {
    vid: {
      type: String,
      default: '',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    value: {
      type: null,
      default: null,
    },
    ignoreValidGreen: {
      type: Boolean,
      default: false,
    },
    showForce: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    innerValue: '',
    init: false,
  }),
  computed: {
    levelForce() {
      if (!this.innerValue || this.innerValue.length < 8) return 0
      let strength = 0
      if (this.innerValue.length >= 8) strength++
      if (/\d/.test(this.innerValue) && /[A-Za-z]/.test(this.innerValue))
        strength++
      if (/[.\-+=?!@#$%^&*]/.test(this.innerValue)) strength++
      return strength
    },
    levelForceMsg() {
      if (this.levelForce === 1) return 'Valida - Débil'
      if (this.levelForce === 2) return 'Valida - Media'
      if (this.levelForce === 3) return 'Valida - Fuerte'
      return ''
    },
    forceGuidance() {
      if (this.levelForce !== 1 && this.levelForce !== 2) return ''
      const v = this.innerValue || ''
      if (!/\d/.test(v)) return 'Incluye números a tu contraseña'
      if (!/[.\-+=?!@#$%^&*]/.test(v))
        return 'Incluye un carácter especial como: @ o $'
      if (!/[A-Za-z]/.test(v)) return 'Incluye letras a tu contraseña'
      return 'Mejora la contraseña'
    },
  },
  watch: {
    innerValue(newVal) {
      this.$emit('input', newVal)
      this.init = true
    },
    value(newVal) {
      this.innerValue = newVal
      this.init = true
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value
    }
  },
  mounted() {
    this.$emit('set-custom-errors', this.setErrors)
  },
  methods: {
    iconRightClick(event) {
      this.$emit('icon-right-click', event)
    },
    onBlur(event) {
      this.$emit('blur', event)
    },
    setErrors(listErrors) {
      this.$refs.provider.applyResult({
        errors: listErrors,
        valid: false,
        failedRules: {},
      })
    },
    levelForceClass(i) {
      if (this.levelForce === 0) return 'inactive'
      if (i < this.levelForce) {
        if (this.levelForce === 1) return 'is-red'
        if (this.levelForce === 2) return 'is-yellow'
        return 'is-green'
      }
      return 'inactive'
    },
  },
}
